module.exports = __webpack_public_path__ + "img/warning-green.080444e3.svg";